import { apiClient } from "./api.js";

export interface BillingStatusResponse {
  userId: number;
  isActive: boolean;
  nextBillingDate: string | null;
  plan: string;
  trialStartedAt: string | null;
  trialUsed: boolean;
  subscription: {
    status: string;
    provider: string;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    cancelAtPeriodEnd: boolean;
    gracePeriodEndsAt: string | null;
  } | null;
  entitlements: {
    canReceiveVacancies: boolean;
    canEditAlerts: boolean;
    maxAlerts: number;
    plan: string;
    status: string;
  };
}

export interface PaymentItem {
  id: string;
  date: string;
  amount: number;
  currency: string;
  status: string;
}

export interface BillingHistoryResponse {
  payments: PaymentItem[];
}

export interface CheckoutResponse {
  orderId: string;
  paymentUrl: string;
  webappPaymentUrl?: string;
  plan: string;
  amount: number;
  displayPrice: string;
}

export interface CancelSubscriptionResponse {
  ok: boolean;
  status: string;
  canceledAt: string;
  currentPeriodEnd?: string;
}

export async function getBillingStatus(): Promise<BillingStatusResponse> {
  return apiClient<BillingStatusResponse>("/api/billing/status");
}

export async function getBillingHistory(): Promise<BillingHistoryResponse> {
  return apiClient<BillingHistoryResponse>("/api/billing/history");
}

export async function createCheckout(plan: string = "premium"): Promise<CheckoutResponse> {
  return apiClient<CheckoutResponse>("/api/billing/checkout", {
    method: "POST",
    body: JSON.stringify({ plan }),
  });
}

export async function cancelSubscription(): Promise<CancelSubscriptionResponse> {
  return apiClient<CancelSubscriptionResponse>("/api/billing/cancel", {
    method: "POST",
    body: JSON.stringify({}),
  });
}
